export const PANELS = {
  FIRST: 'first',
  SECOND: 'second',
  THIRD: 'third',
  FOURTH: 'fourth',
  FIFTH: 'fifth',
  POINTS: 'points',
} as const;

export const CustomMuiAccordionSummaryClass =
  'Custom-Mui-Accordion-summary-class';
export const activeSummaryClass = 'active-summary';
export const CustomMuiAccordionClass = 'Custom-Mui-Accordion-class';
export const disableSelectionClass = 'disable-click';
export const AccordionPanelImageStyle = { width: 70, height: 44 };
export const MuiAccordionElevation = 0;

export const FLOW_OF_JOURNEY = {
  RESERVATION: 'reservation',
  MODIFICATION: 'modification',
} as const;
